export default __webpack_public_path__ + "static/media/AcessosIconWhite.9a15bc44.svg";